import React from 'react';

export default function Toast({ visible, message, error }) {
  return (
    <div
      style={{
        position: 'fixed',
        bottom: 24,
        left: '50%',
        transform: `translateX(-50%) translateY(${visible ? 0 : 16}px)`,
        background: error ? '#ef4444' : 'var(--text-1)',
        color: 'var(--surface)',
        padding: '10px 18px',
        borderRadius: 'var(--r-pill)',
        fontSize: '12.5px',
        fontWeight: 500,
        opacity: visible ? 1 : 0,
        transition: 'opacity .25s, transform .25s',
        zIndex: 9999,
        pointerEvents: 'none',
        boxShadow: 'var(--shadow-md)',
        whiteSpace: 'nowrap',
      }}
    >
      {message}
    </div>
  );
}
